// Suspensão do WhatsApp oficial vista pelo cliente da API.
//
// Com o saldo da linha de crédito esgotado (ou por decisão do operador), o
// WhatsApp oficial da carteira é suspenso: no GLA Conecta nenhuma resposta sai
// pelos números dela, e as mensagens dos clientes continuam chegando. A API em
// si segue ativa — é outra coisa que "API suspensa" (isSuspended).
//
// O estado chega em `cobranca.suspensao { desde, motivo, recado }` na consulta
// de informações da instância. Regra pura: nada de rede nem de relógio aqui.

const texto = (v) => (typeof v === 'string' && v.trim() ? v.trim() : null)

const doisDigitos = (n) => String(n).padStart(2, '0')

// A suspensão em vigor ({ motivo, desde, recado }) ou null. Só "saldo" autoriza
// a tela a falar em recarga; motivo desconhecido conta como manual.
export function suspensaoDaResposta(resposta) {
  const s = resposta && resposta.cobranca && resposta.cobranca.suspensao
  if (!s || typeof s !== 'object' || typeof s.desde !== 'string') return null
  if (Number.isNaN(new Date(s.desde).getTime())) return null
  return { motivo: s.motivo === 'saldo' ? 'saldo' : 'manual', desde: s.desde, recado: texto(s.recado) }
}

// Duas leituras da suspensão dizem a mesma coisa? O polling da tela inicial
// relê a cada 5 s; quando nada mudou o contexto guarda o objeto antigo e o
// painel não redesenha à toa.
export function mesmaSuspensao(a, b) {
  if (!a || !b) return !a && !b
  return a.motivo === b.motivo && a.desde === b.desde && a.recado === b.recado
}

// "hoje, 14:32" ou "19/10, 23:17", na hora de quem está olhando.
function quando(desde, agora) {
  const d = new Date(desde)
  const hoje = new Date(agora)
  const hora = `${doisDigitos(d.getHours())}:${doisDigitos(d.getMinutes())}`
  const mesmoDia =
    d.getFullYear() === hoje.getFullYear() && d.getMonth() === hoje.getMonth() && d.getDate() === hoje.getDate()
  return mesmoDia ? `hoje, ${hora}` : `${doisDigitos(d.getDate())}/${doisDigitos(d.getMonth() + 1)}, ${hora}`
}

// O que a faixa mostra: { titulo, mensagem, rodape, ofereceRecarga } ou null.
// Na suspensão feita pelo operador a recarga não reativa — a faixa mostra o
// recado dele em vez de empurrar um pagamento que não resolve.
export function avisoDaSuspensao(suspensao, agora) {
  if (!suspensao) return null
  const porSaldo = suspensao.motivo === 'saldo'
  return {
    titulo: porSaldo ? 'WhatsApp oficial suspenso por falta de saldo' : 'WhatsApp oficial suspenso',
    mensagem: `Suspenso desde ${quando(suspensao.desde, agora)}. No GLA Conecta as mensagens dos seus clientes continuam chegando, mas nenhuma resposta sai.`,
    // Não é "assim que o pagamento é confirmado": a suspensão só sai com o
    // saldo cobrindo o uso, com a folga (regra do master) — uma recarga menor
    // que o negativo não reativa. Mesmo texto dos avisos do master.
    rodape: porSaldo
      ? 'Reativação automática quando o saldo cobrir o uso, com folga.'
      : suspensao.recado || 'Fale com o suporte para reativar.',
    ofereceRecarga: porSaldo,
  }
}

// O link de recarga vem do servidor; só vira botão se for um endereço https.
export function linkDeRecargaSeguro(url) {
  return typeof url === 'string' && /^https:\/\/[^\s]+$/i.test(url) ? url : null
}
